// Import components that must be opened by the routes
import Home from '@/features/home/presentation/Home.vue'
import Kayaks from '@/features/kayaks/list/presentation/Kayaks.vue'
import Kayak from '@/features/kayaks/detail/presentation/Kayak.vue'
import Paddles from '@/features/paddles/list/presentation/Paddles.vue'
import Accessories from '@/features/accessories/list/presentation/Accessories.vue'
import Offers from '@/features/kayaks/offers/presentation/Offers.vue'
import Contacts from '@/features/contacts/presentation/Contacts.vue'
import NotFound from '@/components/NotFound.vue'

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/kayaks',
    name: 'kayaks',
    component: Kayaks
  },
  {
    path: '/kayaks/:slug',
    name: 'kayak',
    component: Kayak,
    props: true
  },
  {
    path: '/paddles',
    name: 'paddles',
    component: Paddles
  },
  {
    path: '/accessories',
    name: 'accessories',
    component: Accessories
  },
  {
    path: '/offers',
    name: 'offers',
    component: Offers
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: Contacts
  },
  {
    path: '*',
    component: NotFound
  }
]

export default routes
